import { LabResultCSVUploadForm } from '../../components/lab-results/lab-result-csv-upload-form';

function LabResultsCreatePage() {
  return (
    <div>
      <div className="flex flex-row justify-center m-20">
        <div className="min-w-[20rem]">
          <h1 className="text-5xl font-bold mb-8">Create Lab Results</h1>
          <LabResultCSVUploadForm />
        </div>
      </div>
    </div>
  );
}

export default LabResultsCreatePage;
